export default __webpack_public_path__ + "static/media/Goldensky3.8d7d948a.jpg";